
export default {
  name: "ImageGrid",
  props: {
    content: Object,
  },
}
